// extracted by mini-css-extract-plugin
module.exports = {"cart":"CartWidget-module--cart--2uuQ-","cartEmpty":"CartWidget-module--cartEmpty--1Sz1m"};